const { findTasksWithLimitAndOrder } = require("tasks/api")

const findLastTasksUseCase = (data, setData) => {
    const mapData = data.reduce((map, obj) => {
        map[obj.key] = obj.val;
        return map;
    }, {});

    return findTasksWithLimitAndOrder(5, "dateEntrySign", "desc", snapshot => {
        snapshot.docChanges().forEach(change => {
            if (change.type === "added") {
                mapData[change.doc.id] = { id: change.doc.id, ...change.doc.data() }
            } else if (change.type === "modified") {
                mapData[change.doc.id] = { id: change.doc.id, ...change.doc.data() }
            } else if (change.type === "removed") {
                delete mapData[change.doc.id]
            }
        });
        
        const dataOrder = Object.values(mapData).sort((a,b) => new Date(b.dateEntrySign) - new Date(a.dateEntrySign))
        setData(dataOrder)
    })
}

export default findLastTasksUseCase